export default __webpack_public_path__ + "static/loyall-featured-image-integraties-light-accf8bb9fb8bba9d93b2dc9bf503ea07.jpg";